<template>
  <div id="app">
    <div v-if="!loggedIn && auth0">
      <button class="login" v-on:click="login">Login</button>
    </div>
    <template v-if="feeds.length">
      <div class="feed" v-for="feed in feeds" v-bind:key="feed.path">
        <h2>
          {{ feed.path }}
          <a
            v-bind:href="'//' + websiteDomain + '/' + feed.path"
            target="_blank"
          >[open feed]</a>
          <a v-on:click="selectFeed(feed)">[edit feed]</a>
        </h2>
        <h5>Last modified: {{ feed.lastModified }}</h5>
        <template v-if="selectedFeed && selectedFeed.path === feed.path">
          <button v-on:click="createArticle()">New Article</button>
          <div
            v-bind:class="'article' + (selectedArticle && selectedArticle.guid === article.guid ? ' active' : '')"
            v-for="(article, index) in selectedFeed.articles"
            v-bind:key="index"
          >
            <div class="article-header">
              <button v-on:click="moveArticleUp(index)">Up</button>
              <button v-on:click="moveArticleDown(index)">Down</button>
              <input class="title" v-model="article.title" placeholder="Title" />
              <button v-on:click="selectArticle(article)">Edit</button>
              <button v-on:click="deleteArticle(index)">Delete</button>
            </div>
            <template v-if="selectedArticle && selectedArticle.guid === article.guid">
              <textarea class="description" v-model="article.description" placeholder="Description"></textarea>
              <input class="link" v-model="article.link" placeholder="Link" />
              <input class="thumbnail" v-model="article.thumbnail" placeholder="Thumbnail URL" />
              <input class="guid" v-model="article.guid" placeholder="GUID" />
              <input class="pubDate" v-model="article.pubDate" placeholder="Publish date" />
            </template>
          </div>
          <button class="save" v-on:click="saveFeed(selectedFeed)">Save Feed</button>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import createAuth0Client from "@auth0/auth0-spa-js";
import { v4 as uuidv4 } from "uuid";
const fetch = require("node-fetch");

export default {
  name: "App",
  data: () => {
    return {
      auth0: null,
      loggedIn: false,
      user: null,
      websiteDomain: "www.influencerninja.com",
      apiBaseUrl: "https://mkmaglgnjc.execute-api.eu-west-1.amazonaws.com",
      feeds: [],
      selectedFeed: null,
      selectedArticle: null
    };
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      this.auth0 = await createAuth0Client({
        domain: "allsportswhispers.eu.auth0.com",
        client_id: "uAbRCqJeyt0W09gHYLOWQ6iD5PkaKZvU",
        redirect_uri: window.location.origin,
        scope: "data-access"
      });
      await this.getUser();
    },
    async getUser() {
      try {
        await this.auth0.getTokenSilently();
        this.user = await this.auth0.getIdTokenClaims();
        this.loggedIn = true;
        await this.loadFeeds();
      } catch (error) {
        await this.logout();
      }
    },
    async login() {
      try {
        await this.auth0.loginWithPopup();
        await this.getUser();
      } catch (error) {
        await this.logout();
      }
    },
    async logout() {
      if (this.loggedIn === false && this.user === null) {
        return;
      }
      try {
        await this.auth0.logout({
          returnTo: window.location.origin
        });
      } catch (error) {
        console.error(error);
      }
      this.loggedIn = false;
      this.user = null;
    },
    async loadFeeds() {
      const response = await fetch(this.apiBaseUrl + "/feed", {
        headers: {
          Authorization: `Bearer ${this.user.__raw}`
        }
      });
      const data = await response.json();
      this.feeds = data.data;
    },
    async selectFeed(feed) {
      if (this.selectedFeed && this.selectedFeed.path === feed.path) {
        this.selectedFeed = null;
        return;
      }
      this.selectedFeed = feed;
    },
    async moveArticle(oldIndex, newIndex) {
      while (oldIndex < 0) {
        oldIndex += this.selectedFeed.articles.length;
      }
      while (newIndex < 0) {
        newIndex += this.selectedFeed.articles.length;
      }
      if (newIndex >= this.selectedFeed.articles.length) {
        var k = newIndex - this.selectedFeed.articles.length + 1;
        while (k--) {
          this.selectedFeed.articles.push(undefined);
        }
      }
      this.selectedFeed.articles.splice(
        newIndex,
        0,
        this.selectedFeed.articles.splice(oldIndex, 1)[0]
      );
    },
    async moveArticleUp(i) {
      this.moveArticle(i, i - 1);
    },
    async moveArticleDown(i) {
      this.moveArticle(i, i + 1);
    },
    async createArticle() {
      this.selectedFeed.articles.unshift({
        title: "",
        description: "",
        link: "",
        thumbnail: "",
        guid: uuidv4(),
        pubDate: new Date().toUTCString()
      });
    },
    async selectArticle(article) {
      if (this.selectedArticle && this.selectedArticle.guid === article.guid) {
        this.selectedArticle = null;
        return;
      }
      this.selectedArticle = article;
    },
    async deleteArticle(i) {
      this.selectedFeed.articles.splice(i, 1);
    },
    async saveFeed(feed) {
      await fetch(this.apiBaseUrl + "/feed", {
        method: "POST",
        body: JSON.stringify(feed),
        headers: {
          Authorization: `Bearer ${this.user.__raw}`
        }
      });
      alert("Saved!");
    }
  }
};
</script>

<style>
* {
  box-sizing: inherit;
  color: #2c3e50;
  font: 100%/1.5em Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: bold;
}
h1 {
  font-size: 1.5em;
}
h2 {
  font-size: 1.4em;
}
h3 {
  font-size: 1.3em;
}
h4 {
  font-size: 1.2em;
}
h5 {
  font-size: 1.1em;
}

button,
input,
textarea {
  border: 1px solid #2c3e50;
  border-radius: 3px;
  display: block;
  outline: 0;
  padding: 5px;
  width: 100%;
}
button,
a {
  cursor: pointer;
}
textarea {
  height: 75px;
}

#app {
  box-sizing: border-box;
}

.login {
  margin: 10% auto;
  width: 25%;
}

.feed {
  width: 50%;
  margin: 0 auto 50px;
}

.article {
  margin: 0 auto;
}
.article.active {
  background: lightgray;
  margin-top: 10px;
  padding: 0 10px 10px;
}

.article-header {
  display: flex;
}
.article-header button,
.article-header input {
  margin-right: 10px;
}
.article-header button:nth-child(5) {
  margin-right: 0;
}
.article-header button {
  flex: 1;
}
.article-header input {
  flex: 12;
}

.article button,
.article input,
.article textarea {
  margin-top: 10px;
}

.save {
  margin-top: 10px;
}
</style>
